import { AxiosResponse } from "axios";

import { Surveys } from "modules/Surveys/surveys";
import { camelizeObject, snakizeObject } from "shared/helpers/object";
import { ApiBaseUrl, request } from "shared/clients/baseClient";

const getSurveys = (
  params?: Surveys.GetSurveysParams
): Promise<AxiosResponse<Surveys.GetSurveysResponse>> => {
  return request({
    options: {
      url: `${ApiBaseUrl}/survey/`,
      method: "GET",
      params: snakizeObject(params ?? {}),
    },
  }).then((data: AxiosResponse<Surveys.GetSurveysResponseApi>) => {
    return camelizeObject<AxiosResponse<Surveys.GetSurveysResponse>>(data);
  });
};

const getSurvey = (id: number | string): Promise<AxiosResponse<Surveys.Survey>> => {
  return request({
    options: {
      url: `${ApiBaseUrl}/survey/${id}/`,
      method: "GET",
    },
  }).then((data: AxiosResponse<Surveys.SurveyApi>) => {
    return camelizeObject(data);
  });
};

const createSurvey = (params: Surveys.CreateSurveyParams): Promise<number> => {
  return request({
    options: {
      url: `${ApiBaseUrl}/survey/`,
      method: "POST",
      data: snakizeObject(params),
    },
  }).then((data: AxiosResponse<Surveys.SurveyApi>) => {
    return data.data.id;
  });
};

const updateSurvey = (id: number | string, params: Partial<Surveys.Survey>): Promise<number> => {
  return request({
    options: {
      url: `${ApiBaseUrl}/survey/${id}/`,
      method: "PATCH",
      data: snakizeObject(params),
    },
  }).then((data: AxiosResponse<Surveys.SurveyApi>) => {
    return data.data.id;
  });
};

const deleteSurvey = (id: number) => {
  return request({
    options: {
      url: `${ApiBaseUrl}/survey/${id}/`,
      method: "DELETE",
    },
  });
};

export const surveysClient = {
  getSurveys,
  getSurvey,
  createSurvey,
  updateSurvey,
  deleteSurvey,
};
